import React, { FC } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import TrelloCardsPage from "./TrelloCards/TrelloCardsPage";
import TopPage from "./TopPage";

const App: FC = () => {
  return (
    <CookiesProvider>
      <Router>
        <Routes>
          <Route path="/" element={<TopPage />} />
          <Route path="/trello-cards" element={<TrelloCardsPage />} />
        </Routes>
      </Router>
    </CookiesProvider>
  );
};

export default App;
